
export function checkLogin() {

        let resp = window.localStorage.getItem("token-nestorsurf-manager"); //* * * sessionstorage item is initialized by loginAdmin in requete.js

        return (resp !== null && resp !== "") // user already logged?
       
}